import React from "react";

import { LookupCloudAssetItem } from "../../../content-ingestion/common/lookup-cloud-asset/LookupCloudAssetItem";
import { LookupCloudAssetsModal } from "../../../content-ingestion/common/lookup-cloud-asset/LookupCloudAssetsModal";
import { LookupContentItem } from "../../../content-ingestion/common/lookup-content/LookupContentItem";
import { LookupContentModal } from "../../../content-ingestion/common/lookup-content/LookupContentModal";
import { LookupHistoryItem } from "../../../content-ingestion/common/lookup-history/LookupHistoryList";
import { LookupHistoryModal } from "../../../content-ingestion/common/lookup-history/LookupHistoryModal";

export enum LookupAction {
    LookupHistory = 1,
    LookupContent = 2,
    LookupCloudAssets = 3
}

type LookupModalManagerProps = {
    action?: LookupAction;
    onClose: () => void;
    setContentFromLookupHistory: (item: LookupHistoryItem) => void;
    setContentFromLookupContent: (item: LookupContentItem) => void;
    setContentFromLookupCloudAsset: (item: LookupCloudAssetItem) => void;
};

export const LookupModalManager = ({
    action,
    onClose,
    setContentFromLookupHistory,
    setContentFromLookupContent,
    setContentFromLookupCloudAsset
}: LookupModalManagerProps): JSX.Element => {
    const onClickForHistory = (item: LookupHistoryItem) => {
        setContentFromLookupHistory(item);
        onClose();
    };

    const onClickForContent = (item: LookupContentItem) => {
        setContentFromLookupContent(item);
        onClose();
    };

    const onClickForCloudAssets = (item: LookupCloudAssetItem) => {
        setContentFromLookupCloudAsset(item);
        onClose();
    };

    switch (action) {
        case LookupAction.LookupHistory:
            return <LookupHistoryModal isOpen={true} onClick={onClickForHistory} onClose={onClose} />;
        case LookupAction.LookupContent:
            return <LookupContentModal isOpen={true} onClick={onClickForContent} onClose={onClose} />;
        case LookupAction.LookupCloudAssets:
            return <LookupCloudAssetsModal isOpen={true} onClick={onClickForCloudAssets} onClose={onClose} />;
        default:
            return <></>;
    }
};
